import { Col, Row } from "@/atoms"
import { SensorUsageWidget } from "./SensorUsageWidget"

import { AverageUsageWidget } from "./AverageUsageWidget"

export const HeaderDeploymentsTab = () => {
  return (
    <Row gutter={10} className="sticky-section-tab-template-ks">
      <Col span={14}>
        <SensorUsageWidget />
      </Col>
      <Col span={10}>
        <AverageUsageWidget />
      </Col>
    </Row>
  )
}
